module.exports = __webpack_public_path__ + "static/img/message.d076b10.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/message.png
// module id = ObPQ
// module chunks = 2